import { MessageSquare } from "lucide-react";
import { useTranslation } from "@/packages/utils";
import type { UIChecklistItem } from "@/packages/types";

export function NotesContent({ item }: { item: UIChecklistItem }) {
  const { t } = useTranslation("audits");

  if (!item.notes) {
    return (
      <div className="flex flex-col items-center text-center py-8">
        <div
          className="flex h-10 w-10 items-center justify-center rounded-full mb-3"
          style={{ backgroundColor: "rgba(232, 115, 74, 0.1)" }}
        >
          <MessageSquare size={18} className="text-accent" />
        </div>
        <p className="text-[13px] text-muted">
          {t("checklist.overview.noNotes")}
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      <div className="rounded-lg border border-border/60 bg-page/50 p-3">
        <p className="text-[12px] text-secondary leading-relaxed">
          {item.notes}
        </p>
      </div>
    </div>
  );
}
